export default ($stateProvider) => {
  $stateProvider
    .state('wrapper.agent-center-list', {
      url: 'agent-center',
      template: '<nets-agent-center-list></nets-agent-center-list>',
    });
};
